export function getInvoiceRowCheckboxKey(item) {
  return `${item.serviceKey}-${item.productShapeId}`;
}

/** Catalog / invoice unit price only (not insurance discount lookup). */
export function getInvoiceItemEffectiveUnitPrice(item) {
  return Number(item.price ?? item.servicePrice ?? 0);
}

/** Unit price from item is zero — row must never be confirmable via invoice checkboxes. */
export function isInvoiceRowZeroEffectiveUnit(item) {
  const unitPrice = getInvoiceItemEffectiveUnitPrice(item);
  return Number.isFinite(unitPrice) && unitPrice === 0;
}

export function getInvoiceCheckableRowKeys(items) {
  const list = Array.isArray(items) ? items : [];
  return list.filter(item => !isInvoiceRowZeroEffectiveUnit(item)).map(getInvoiceRowCheckboxKey);
}

/**
 * True when every non–zero-price line is checked. Zero-price lines are never checkable and are ignored.
 * If every line is zero-priced, returns false.
 */
export function isAllInvoiceRowsConfirmed(dispensedOrderItems, checkedKeys) {
  const items = Array.isArray(dispensedOrderItems) ? dispensedOrderItems : [];
  if (!items.length) return false;
  const checked = Array.isArray(checkedKeys) ? checkedKeys : [];
  const billableItems = items.filter(item => !isInvoiceRowZeroEffectiveUnit(item));
  if (!billableItems.length) return false;
  return billableItems.every(item => checked.includes(getInvoiceRowCheckboxKey(item)));
}
